import React, { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';
import api from '../api/client';

import { COLORI as FEDERAZIONE_COLORI, etichetta } from '../utils/tessere';

export default function TessereList() {
  const [tessere, setTessere] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tesseramenti/me')
      .then(r => setTessere(r.data))
      .catch(() => setTessere([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-sm)' }}>Caricamento...</div>;

  if (tessere.length === 0) {
    return (
      <div style={s.vuoto}>
        <CreditCard size={22} color="#555"/>
        <div>Nessun tesseramento registrato al momento. Se ti sei già tesserato, contatta lo staff per l'associazione del codice.</div>
      </div>
    );
  }

  return (
    <div style={s.grid}>
      {tessere.map(t => (
        <div key={t.id} style={s.card}>
          <div style={{ ...s.badge, background:`${FEDERAZIONE_COLORI[t.federazione]}20`, color:FEDERAZIONE_COLORI[t.federazione], borderColor:`${FEDERAZIONE_COLORI[t.federazione]}40` }}>{etichetta(t.federazione)}</div>
          <div style={s.numero}>{t.numero_tessera}</div>
          <div style={s.riga}><span style={s.label}>STAGIONE</span><span>{t.stagione}</span></div>
          {t.data_scadenza && <div style={s.riga}><span style={s.label}>SCADENZA</span><span>{new Date(t.data_scadenza).toLocaleDateString('it-IT')}</span></div>}
        </div>
      ))}
    </div>
  );
}

const s = {
  vuoto:  { display:'flex', alignItems:'center', gap:'12px', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'16px', color:'var(--text-dim)', fontSize:'var(--font-size-sm)' },
  grid:   { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:'12px' },
  card:   { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'12px', padding:'16px', display:'flex', flexDirection:'column', gap:'8px' },
  badge:  { alignSelf:'flex-start', padding:'3px 10px', borderRadius:'6px', border:'1px solid', fontSize:'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px' },
  numero: { fontFamily:'monospace', fontSize:'var(--font-size-lg)', fontWeight:'700', letterSpacing:'1px' },
  riga:   { display:'flex', justifyContent:'space-between', fontSize:'var(--font-size-xs)', color:'var(--text-dim)' },
  label:  { fontWeight:'700', letterSpacing:'1px', color:'#555' },
};
